
const en = [
  { name: "English", value: "en", text: "English" },
  { name: "German", value: "de", text: "German" }
];

const de = [
  { name: "Englisch", value: "en", text: "Englisch" },
  { name: "Deutsch", value: "de", text: "Deutsch" }
];
var output = { de: de, en: en };

export default output;



// WEBPACK FOOTER //
// ./src/config/data/languages.js